module.exports = __webpack_public_path__ + "static/media/icon-password.3a51cdab.png";